const isObject = (item) => item !== null && typeof item === "object" && !Array.isArray(item);
export {
  isObject
};
//# sourceMappingURL=utils.js.map
